import { RumbleIcon } from 'assets/RumbleIcon';
import { TelegramIcon } from 'assets/TelegramIcon';
import { XIcon } from 'assets/XIcon';
import { YoutubeIcon } from 'assets/YoutubeIcon';
import cx from 'classnames';
import React from 'react';

import Styles from './styles.module.scss';

interface SocialMediaButtonsProps {
    className?: string;
}

export function SocialMediaButtons(props: SocialMediaButtonsProps): React.ReactElement {
    return (
        <div className={cx(Styles.social, props.className)}>
            <a aria-label="Telegram" href="https://t.me/BankXio" rel="noopener noreferrer" target="_blank" title="Telegram">
                <TelegramIcon />
            </a>
            <a aria-label="YouTube" href="https://www.youtube.com/@BankXio" rel="noopener noreferrer" target="_blank" title="YouTube">
                <YoutubeIcon />
            </a>
            <a aria-label="X" href="https://x.com/bankxio" rel="noopener noreferrer" target="_blank" title="X">
                <XIcon />
            </a>
            <a aria-label="Rumble" href="https://rumble.com/c/BankXio" rel="noopener noreferrer" target="_blank" title="Rumble">
                <RumbleIcon />
            </a>
        </div>
    );
}
